import i18n from '../../utils/i18n';
import BlockerButtonHelper from './button_helper';
import BlockerSignIn from './sign_in';

export default class Blocker {
  constructor(options = {}) {
    this._tech = options.tech;
    this._data = options.data;
    this._isShown = false;
    this._blockerSignIn = new BlockerSignIn({ tech: options.tech });
    this._buttonHelper = new BlockerButtonHelper({ tech: options.tech, data: options.data })
    this._uuid = options.uuid;
  }

  get uuid() {
    return this._uuid;
  }

  get tech() {
    return this._tech;
  }

  get data() {
    return this._data;
  }

  get isShown() {
    return this._isShown;
  }

  get buttonHelper() {
    return this._buttonHelper;
  }

  get blockerSignIn() {
    return this._blockerSignIn;
  }

  get config() {
    return {
      geoblock: {
        message: i18n('blocker.geoblock'),
        ctaButtons: [
          this.buttonHelper.exploreVidioButton({
            text: i18n('blocker.geoblock.cta'),
            type: 'black'
          }),
          this.buttonHelper.withDirectLinkButton({
            text: i18n('blocker.geoblock.additional_cta'),
            href: 'https://support.vidio.com/support/solutions/articles/43000656971-mengapa-konten-tidak-tersedia-di-negara-saya',
            type: 'white',
          })
        ],
        withBgImg: true,
      },
      network_error: {
        message: i18n('blocker.network_error'),
        ctaButtons: [
          this.buttonHelper.retryButton({
            text: i18n('blocker.network_error.cta'),
            type: 'black',
          }),
          this.buttonHelper.withDirectLinkButton({
            text: i18n('blocker.network_error.additional_cta'),
            href: 'https://support.vidio.com/support/solutions/articles/43000656970-bagaimana-memecahkan-masalah-jaringan',
            type: 'white',
          }),
        ],
      },
      media_error: {
        message: i18n('blocker.media_error'),
        ctaButtons: [
          this.buttonHelper.reportButton({
            text: i18n('blocker.media_error.cta'),
            code: 3,
            type: 'black',
          }),
          this.buttonHelper.withDirectLinkButton({
            text: i18n('blocker.media_error.additional_cta'),
            href: 'https://support.vidio.com/support/solutions/articles/43000656973-mengapa-saya-tidak-dapat-memproses-media',
            type: 'white',
          }),
        ],
      },
      drm: {
        message: i18n('blocker.drm'),
        ctaButtons: [
          this.buttonHelper.exploreVidioButton({
            text: i18n('blocker.drm.cta'),
            type: 'black'
          }),
          this.buttonHelper.withDirectLinkButton({
            text: i18n('blocker.drm.additional_cta'),
            href: 'https://support.vidio.com/support/solutions/articles/43000656969-apa-itu-drm',
            type: 'white'
          })
        ],
        withBgImg: true,
      },
      general_error: {
        message: i18n('blocker.general_error'),
        ctaButtons: [
          this.buttonHelper.retryButton({
            text: i18n('blocker.general_error.cta'),
            type: 'black',
          }),
          this.buttonHelper.reportButton({
            text: i18n('blocker.general_error.additional_cta'),
            code: 6,
            type: 'white'
          }),
        ],
      },
      fetching_error: {
        message: i18n('blocker.fetching_error'),
        ctaButtons: [
          this.buttonHelper.retryButton({
            text: i18n('blocker.fetching_error.cta'),
            type: 'black',
          }),
          this.buttonHelper.reportButton({
            text: i18n('blocker.fetching_error.additional_cta'),
            code: 1,
            type: 'white'
          }),
        ],
      },
      media_not_supported: {
        message: i18n('blocker.media_not_supported'),
        ctaButtons: [
          this.buttonHelper.reportButton({
            text: i18n('blocker.media_not_supported.cta'),
            code: 4,
            type: 'black'
          }),
          this.buttonHelper.withDirectLinkButton({
            text: i18n('blocker.media_not_supported.additional_cta'),
            href: 'https://support.vidio.com/support/solutions/articles/43000656974-bagaimana-memecahkan-kendala-perangkat',
            type: 'white'
          }),
        ],
      },
      not_supported_browser: {
        message: i18n('blocker.not_supported_browser'),
        ctaButtons: [
          this.buttonHelper.downloadButton({ type: 'black' }),
          this.buttonHelper.reportButton({
            text: i18n('blocker.not_supported_browser.additional_cta'),
            code: 8,
            type: 'white',
          }),
        ],
      },
      hdcp: {
        message: i18n('blocker.hdcp'),
        ctaButtons: [
          this.buttonHelper.exploreVidioButton({
            text: i18n('blocker.hdcp.cta'),
            type: 'black',
          }),
          this.buttonHelper.withDirectLinkButton({
            text: i18n('blocker.hdcp.additional_cta'),
            href: 'https://support.vidio.com/support/solutions/articles/43000642152-hdcp-information',
            type: 'white',
          })
        ],
        withBgImg: true,
      },
    }
  }

  renderBlocker(type) {
    const config = this.config[type];
    if (config) {
      return this.renderBlockerWithParam(config);
    }
  }

  renderBlockerWithParam({ message, ctaButtons = [], haveCloseButton = true, withBgImg = false }) {
    const element = document.createElement('div');
    element.className = 'vjs-player-error__section';
    element.innerHTML = `<div class="vjs-player-error__container">
      <div class="vjs-player-error__header">
        <h3 class="vjs-player-error__title-revamp">${message.title}</h3>
        <div class="vjs-player-error__subtitle-revamp">${message.subtitle}</div>
        <div class="vjs-player-error__btn-container"></div>
      </div>
    </div>`;
    if (withBgImg) {
      element.style.backgroundImage = "url('" + this.data?.videoBlockerImageUrl() + "')";
    }

    let container = element.querySelector('.vjs-player-error__container');

    if (haveCloseButton) {
      container.appendChild(this.closeButton(element));
    }

    let ctaContainer = element.querySelector('.vjs-player-error__btn-container');
    ctaButtons.forEach(button => {
      ctaContainer.appendChild(button);
    });

    this.styleContainer();
    this.showMessage(element);
    return element;
  }

  showMessage(dom) {
    const vjsContainerEl = document.querySelector('.video-js');
    if (vjsContainerEl) {
      vjsContainerEl.appendChild(dom);
      this._isShown = true;
    }
  }

  // this is for blocker that showed when videojs not initiated yet
  styleContainer() {
    const vod_player = document.querySelector('#' + this.data.playerId());
    if (vod_player && !vod_player.classList.contains('video-js')) {
      vod_player.classList.add(
        'video-js',
        'vjs-fluid',
        'vod-player-dimensions'
      );
    }
  }

  closeButton(parentElement) {
    let element = document.createElement('button');
    element.className = 'vjs-player-error__close-btn';
    element.innerHTML = '&times;';
    element.onclick = () => this.onCloseButtonClick(parentElement);
    return element;
  }

  onCloseButtonClick(parentElement) {
    parentElement.remove();
    this.tech.error(null);
    this._isShown = false;
  }

  showSignInBlocker() {
    this.blockerSignIn.show();
  }
}
